import axios, { AxiosInstance } from "axios";
import {
  ChargeParams,
  GetCustomersParams,
  GetTransactionParams,
  StaxInterface,
} from "./StaxInterface";
import {
  ChargeResponse,
  Customer,
  PaymentMethod,
  TransactionsResponse,
} from "./models";
import * as normalizers from "./normalizers";
import * as denormalizers from "./denormalizers";

export interface StaxDatasourceConfig {
  baseURL: string;
  apiKey: string;
}

export class StaxDatasource implements StaxInterface {
  private client: AxiosInstance;

  constructor(config: StaxDatasourceConfig) {
    const { baseURL, apiKey } = config;

    this.client = axios.create({
      baseURL,
      headers: {
        Authorization: `Bearer ${apiKey}`,
        "Content-Type": "application/json",
        Accept: "application/json",
      },
    });
  }

  async getCustomers(params: GetCustomersParams): Promise<Customer[]> {
    let qs = "";
    if (params.search) qs += `keywords[]=${params.search}`;

    const { data } = await this.client.get(`/customer?${qs}`);

    return normalizers.getCustomers(data.data);
  }

  async getPaymentMethods(customerId: string): Promise<PaymentMethod[]> {
    const { data } = await this.client.get(
      `/customer/${customerId}/payment-method`
    );

    return normalizers.getPaymentMethods(data);
  }

  async charge(params: ChargeParams): Promise<ChargeResponse> {
    const payload = denormalizers.toCharge(params);

    const { data } = await this.client.post("/charge", payload);

    return normalizers.getChargeResponse(data);
  }

  async sendEmailReceipt(transactionId: string): Promise<boolean> {
    await this.client.post(`/transaction/${transactionId}/receipt/email`);

    return true;
  }

  async getTransactions(
    params: GetTransactionParams
  ): Promise<TransactionsResponse> {
    const startDate = `${params.date} 00:00:00`;
    const endDate = `${params.date} 23:59:59`;
    let qs = `page=${params.page}&per_page=100&order=DESC&sort=total&startDate=${startDate}&endDate=${endDate}`;
    const { data } = await this.client.get(`/transaction?${qs}`);

    return normalizers.getTransactions(data);
  }
}
